const Coinbase = () => (
    <svg
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='coinbase'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM15.9999 24.9755C20.957 24.9755 24.9755 20.957 24.9755 15.9999C24.9755 11.0428 20.957 7.02431 15.9999 7.02431C11.0428 7.02431 7.02431 11.0428 7.02431 15.9999C7.02431 20.957 11.0428 24.9755 15.9999 24.9755Z'
            fill='white'
        />
        <rect x='12.7998' y='12.7998' width='6.4' height='6.4' fill='white' />
    </svg>
);

export default Coinbase;
